var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMobile = function SvgMobile(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 70 70"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#2F68D1",
    fillRule: "evenodd",
    d: "M19.556 4A3.156 3.156 0 0 0 16.4 7.156v55.688A3.156 3.156 0 0 0 19.556 66h30.888a3.156 3.156 0 0 0 3.156-3.156V7.156A3.156 3.156 0 0 0 50.444 4zm2.142 3.72c-.871 0-1.578.706-1.578 1.578v51.404c0 .871.707 1.578 1.578 1.578h26.604c.871 0 1.578-.707 1.578-1.578V9.298c0-.871-.707-1.578-1.578-1.578z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#FF9D43",
    strokeLinecap: "round",
    strokeWidth: 3.156,
    d: "M25.153 13.118H40.47"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#2F68D1",
    d: "M24.059 19.682h21.882v12.035H24.059zM24.059 54.694h21.882v4.376H24.059z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#6C9BF1",
    d: "M35 36.094h10.941v14.223H35z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#B4CFFF",
    d: "M24.059 36.094h7.659v14.223h-7.659z"
  })));
};
export default SvgMobile;